import { Component, type ReactNode } from 'react';
import { ErrorFallback } from './ErrorFallback';
import { track } from '@/lib/analytics';
import { Events } from '@/lib/analytics-events';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] Erro capturado:', error);
    console.error('[ErrorBoundary] Stack:', errorInfo.componentStack);
    track(Events.appError(
      error.name,
      errorInfo.componentStack || '',
      typeof window !== 'undefined' ? window.location.pathname : ''
    ));
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error} />;
    }

    return this.props.children;
  }
}
